import { render } from "./UiBaseLoader.vue?vue&type=template&id=5ddc4016&scoped=true&lang=pug"
const script = {}

import "./UiBaseLoader.vue?vue&type=style&index=0&id=5ddc4016&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddc4016"]])

export default __exports__